const eventsImg = [...Array(198)].map((_, index) => ({
  imgPath: `https://budgitawards.s3.eu-west-2.amazonaws.com/2022_awards/img_${
    index + 1
  }.jpg`,
}));

export default eventsImg;
